export const DEBUG = true;
export const DEFAULT_ERROR_MSG = 'An error occurred, please try again later';

export const debugLog = (...message) => {
    if (DEBUG) {
        console.log(...message);
    }
};
export const debugWarn = (...message) => {
    if (DEBUG) {
        console.warn(...message);
    }
};
export const debugError = (...message) => {
    if (DEBUG) {
        console.error(...message);
    }
};
export const debugTable = (...message) => {
    if (DEBUG) {
        console.table(...message);
    }
};
export const debugObject = (...message) => {
    if (DEBUG) {
        console.object(...message);
    }
};
